import { alpha } from '@material-ui/core';

// ----------------------------------------------------------------------

export default function Card(theme) {
  // UI kit "sticker" card: bold ink-brown outline + flat, non-blurred offset
  // shadow (grey[800] is the exact brand ink #514538 the kit's --shadow-ink is built on).
  const isLight = theme.palette.mode === 'light';

  return {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: isLight ? `4px 5px 0 0 ${alpha(theme.palette.grey[800], 0.85)}` : 'none',
          border: `2.5px solid ${isLight ? theme.palette.grey[800] : theme.palette.grey[300]}`,
          borderRadius: theme.shape.borderRadiusSm,
          position: 'relative',
          zIndex: 0 // Fix Safari overflow: hidden with border radius
        }
      }
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: 'h6' },
        subheaderTypographyProps: {
          variant: 'body2',
          marginTop: theme.spacing(0.5)
        }
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(2.5, 3, 0)
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3)
        }
      }
    }
  };
}
